import React from 'react';
import { Box, Button, Modal } from '@mui/material';
import CloseButton from '../Buttons/CloseButton';

export interface ActionConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  confirmText: React.ReactNode;
  denyText: React.ReactNode;
}

export function ActionConfirmationModal({
  onClose,
  onConfirm,
  open,
  title,
  description,
  confirmText,
  denyText,
}: ActionConfirmationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="twp flex justify-end items-center"
    >
      <Box className="w-[500px] bg-base-primary-inverse m-auto max-h-[284px] overflow-auto rounded-xl">
        <div className="pt-3 pr-3 pl-5 pb-3 border-b border-b-neutral-200 flex flex-row-reverse">
          <CloseButton onClick={onClose} />
        </div>
        <Box className="mt-5 ml-6 mb-5 mr-6">
          <div className="text-2xl font-medium pb-2.5">{title}</div>
          <div className="text-sm font-normal">{description}</div>
        </Box>
        <div className="flex flex-row-reverse gap-[8px] pt-3 pb-3 pr-3 border-t border-t-neutral-200">
          <Button
            className="h-9 rounded-lg pl-4 pr-4 drop-shadow font-medium normal-case bg-danger-700 text-base-primary-inverse hover:bg-danger-800"
            onClick={onClose}
          >
            {confirmText}
          </Button>
          <Button
            className="h-9 rounded-lg pl-4 pr-4 drop-shadow font-medium normal-case bg-base-primary-inverse border border-neutral-200 border-solid"
            onClick={onConfirm}
          >
            {denyText}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
